export const lockTableIcons = {
  denyEntry: "🔒",
};
